import { Directive, Input } from '@angular/core';
import { CdkTreeNodePadding } from '@angular/cdk/tree';

@Directive({
  selector: '[mcraiTreeNodePadding]',
  providers: [{ provide: CdkTreeNodePadding, useExisting: PaddingDirective }]
})
export class PaddingDirective<T> extends CdkTreeNodePadding<T> {

  @Input('mcraiTreeNodePadding') level: number;
  @Input('mcraiTreeNodePaddingIndent') indent: number;

}